import { ConnectorGroup } from 'models/ConnectorGroup';
import { Connector } from 'models/Connector';
import { isConnectorDeleted } from 'utils/connectorDeletion';

/** Connectors that belong to the connector group being deleted. */
export const getConnectorGroupConnectors = (
  connectorGroupId: number,
  connectors: Connector[]
): Connector[] =>
  connectors.filter(connector => connector.connector_group_id === connectorGroupId);

/**
 * A connector group may be deleted only when every related connector is disabled or already deleted.
 * Returns true when at least one related connector is still enabled and not deleted.
 */
export const connectorGroupHasEnabledActiveConnectors = (
  connectorGroupId: number,
  connectors: Connector[]
): boolean =>
  getConnectorGroupConnectors(connectorGroupId, connectors).some(
    connector => connector.enabled && !isConnectorDeleted(connector)
  );

export const getConnectorGroupDeleteBlockMessage = (
  connectorGroup: ConnectorGroup,
  connectors: Connector[]
): string | null => {
  if (connectorGroupHasEnabledActiveConnectors(connectorGroup.id, connectors)) {
    return 'This connector group cannot be deleted because it has enabled connectors.';
  }
  return null;
};
